/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCorporationsCorporationIdFwStatsKills } from './GetCorporationsCorporationIdFwStatsKills';
import {
    GetCorporationsCorporationIdFwStatsKillsFromJSON,
    GetCorporationsCorporationIdFwStatsKillsFromJSONTyped,
    GetCorporationsCorporationIdFwStatsKillsToJSON,
    GetCorporationsCorporationIdFwStatsKillsToJSONTyped,
} from './GetCorporationsCorporationIdFwStatsKills';
import type { GetCorporationsCorporationIdFwStatsVictoryPoints } from './GetCorporationsCorporationIdFwStatsVictoryPoints';
import {
    GetCorporationsCorporationIdFwStatsVictoryPointsFromJSON,
    GetCorporationsCorporationIdFwStatsVictoryPointsFromJSONTyped,
    GetCorporationsCorporationIdFwStatsVictoryPointsToJSON,
    GetCorporationsCorporationIdFwStatsVictoryPointsToJSONTyped,
} from './GetCorporationsCorporationIdFwStatsVictoryPoints';

/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdFwStatsOk
 */
export interface GetCorporationsCorporationIdFwStatsOk {
    /**
     * The enlistment date of the given corporation into faction warfare. Will not be included if corporation is not enlisted in faction warfare
     * @type {Date}
     * @memberof GetCorporationsCorporationIdFwStatsOk
     */
    enlistedOn?: Date;
    /**
     * The faction the given corporation is enlisted to fight for. Will not be included if corporation is not enlisted in faction warfare
     * @type {number}
     * @memberof GetCorporationsCorporationIdFwStatsOk
     */
    factionId?: number;
    /**
     * 
     * @type {GetCorporationsCorporationIdFwStatsKills}
     * @memberof GetCorporationsCorporationIdFwStatsOk
     */
    kills: GetCorporationsCorporationIdFwStatsKills;
    /**
     * How many pilots the enlisted corporation has. Will not be included if corporation is not enlisted in faction warfare
     * @type {number}
     * @memberof GetCorporationsCorporationIdFwStatsOk
     */
    pilots?: number;
    /**
     * 
     * @type {GetCorporationsCorporationIdFwStatsVictoryPoints}
     * @memberof GetCorporationsCorporationIdFwStatsOk
     */
    victoryPoints: GetCorporationsCorporationIdFwStatsVictoryPoints;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdFwStatsOk interface.
 */
export function instanceOfGetCorporationsCorporationIdFwStatsOk(value: object): value is GetCorporationsCorporationIdFwStatsOk {
    if (!('kills' in value) || value['kills'] === undefined) return false;
    if (!('victoryPoints' in value) || value['victoryPoints'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdFwStatsOkFromJSON(json: any): GetCorporationsCorporationIdFwStatsOk {
    return GetCorporationsCorporationIdFwStatsOkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdFwStatsOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdFwStatsOk {
    if (json == null) {
        return json;
    }
    return {
        
        'enlistedOn': json['enlisted_on'] == null ? undefined : (new Date(json['enlisted_on'])),
        'factionId': json['faction_id'] == null ? undefined : json['faction_id'],
        'kills': GetCorporationsCorporationIdFwStatsKillsFromJSON(json['kills']),
        'pilots': json['pilots'] == null ? undefined : json['pilots'],
        'victoryPoints': GetCorporationsCorporationIdFwStatsVictoryPointsFromJSON(json['victory_points']),
    };
}

export function GetCorporationsCorporationIdFwStatsOkToJSON(json: any): GetCorporationsCorporationIdFwStatsOk {
    return GetCorporationsCorporationIdFwStatsOkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdFwStatsOkToJSONTyped(value?: GetCorporationsCorporationIdFwStatsOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enlisted_on': value['enlistedOn'] == null ? undefined : ((value['enlistedOn']).toISOString()),
        'faction_id': value['factionId'],
        'kills': GetCorporationsCorporationIdFwStatsKillsToJSON(value['kills']),
        'pilots': value['pilots'],
        'victory_points': GetCorporationsCorporationIdFwStatsVictoryPointsToJSON(value['victoryPoints']),
    };
}

